import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import Post from "../components/post"

const PageTemplate = ({ data: { page } }) => {
  return (
    <Layout>
      <Post data={page} />
    </Layout>
  )
}

PageTemplate.propTypes = {
  data: PropTypes.object,
}

export const Head = ({ data: { page } }) => {
  return (
    <Meta
      data={{
        title: page.title,
        socialImage: page.images?.[0]?.images.fallback.src,
      }}
    />
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query ($id: String!) {
    page: pagesJson(id: { eq: $id }) {
      title
      body
      links {
        id
        url
        text
      }
      files {
        id
        url
        text
      }
      images {
        ...NKimageFragment
      }
    }
  }
`
